export default __webpack_public_path__ + "static/media/ui-status-error.ffadfee3.svg";